import React, { useEffect, useState } from 'react'
import SimpleModal from 'components/SimpleModal'
import { CustomButton, SimpleTitleCard } from 'styles/global'
import { ModalContent, Section } from '../style'
import { useSelector } from 'react-redux'
import { ApplicationState } from 'store'
import { KANBAN } from 'store/modules/kanban/types'
import { Col, Row } from 'reactstrap'
import CustomSelect from 'components/Select'
import useRedux from 'hooks/useRedux'
import * as kanbanActions from 'store/modules/kanban/actions'
import InputCustom from 'components/Inputs'
import moment from 'moment'

interface ModalAgendamentoProps {
  isOpen: boolean
}

const ModalAgendamento = ({ isOpen }: ModalAgendamentoProps) => {
  const { agendamento, optionsSelect, loadingSelect, modalKanban } =
    useSelector<ApplicationState, KANBAN>((state) => state.kanban)

  const { dispatch } = useRedux()

  const [dataAgendamento, setDataAgendamento] = useState('')
  const [horarioAgendamento, setHorarioAgendamento] = useState('')
  const [invalidDataAgendamento, setInvalidDataAgendamento] = useState(false)
  const [invalidHorarioAgendamento, setInvalidHorarioAgendamento] =
    useState(false)
  const [invalidTipoAgendamento, setInvalidTipoAgendamento] = useState(false)

  const validateForm = () => {
    let hasError = false

    if (!dataAgendamento) {
      setInvalidDataAgendamento(true)
      hasError = true
    } else if (
      moment(dataAgendamento).isBefore(moment().format('YYYY-MM-DD'))
    ) {
      setInvalidDataAgendamento(true)
      hasError = true
    } else {
      setInvalidDataAgendamento(false)
    }

    if (!horarioAgendamento) {
      setInvalidHorarioAgendamento(true)
      hasError = true
    } else {
      const agendamentoDateTime = moment(
        `${dataAgendamento} ${horarioAgendamento}`
      )
      const agora = moment()

      if (agendamentoDateTime.isBefore(agora)) {
        setInvalidHorarioAgendamento(true)
        hasError = true
      } else {
        setInvalidHorarioAgendamento(false)
      }
    }

    if (!agendamento.tipoAgendamentoId) {
      setInvalidTipoAgendamento(true)
      hasError = true
    } else {
      setInvalidTipoAgendamento(false)
    }

    return !hasError
  }

  const handleConfirmar = () => {
    if (!validateForm()) return
    dispatch(
      kanbanActions.setAgendamento({
        pipelineEtapaClienteId: modalKanban.informacoes.pipelineEtapaClienteId,
        dataAtendimento: dataAgendamento,
        horario: horarioAgendamento,
        tipoAgendamentoId: agendamento.tipoAgendamentoId,
        observacao: agendamento.observacao,
        ddd: modalKanban.informacoes.ddd || '',
        telefone: modalKanban.informacoes.numero || ''
      })
    )

    dispatch(kanbanActions.criarAgendamentoSaga())
  }

  const handleClose = () => {
    setDataAgendamento('')
    setHorarioAgendamento('')
    setInvalidDataAgendamento(false)
    setInvalidHorarioAgendamento(false)
    setInvalidTipoAgendamento(false)

    dispatch(kanbanActions.setIsOpenModalAgendamento(false))
    dispatch(kanbanActions.cleanAgendamento())
  }

  useEffect(() => {
    if (isOpen) {
      dispatch(kanbanActions.getTiposAgendamentoSaga())
    }
  }, [isOpen, dispatch])

  return (
    <SimpleModal
      dataBackdrop="static"
      isOpen={isOpen}
      toggle={handleClose}
      size="md"
      header={<SimpleTitleCard>Agendar Atendimento</SimpleTitleCard>}
      footer={
        <Row>
          <Col>
            <CustomButton background="#662D91" onClick={handleClose}>
              Cancelar
            </CustomButton>
          </Col>
          <Col>
            <CustomButton
              background="var(--verde-riber)"
              onClick={handleConfirmar}
            >
              Agendar
            </CustomButton>
          </Col>
        </Row>
      }
    >
      <ModalContent>
        <Section>
          <div className="d-flex flex-column gap-3">
            <Row>
              <Col md={6}>
                <label className="form-label">Data do atendimento *</label>
                <InputCustom
                  type="date"
                  value={dataAgendamento}
                  onChange={(e) => {
                    setDataAgendamento(e.target.value || '')
                    if (e.target.value) setInvalidDataAgendamento(false)
                  }}
                  invalid={invalidDataAgendamento}
                />
                {invalidDataAgendamento && (
                  <div className="text-danger small mt-1">
                    Selecione uma data válida (posterior a hoje)
                  </div>
                )}
              </Col>
              <Col md={6}>
                <label className="form-label">Horário *</label>
                <InputCustom
                  type="time"
                  value={horarioAgendamento}
                  onChange={(e) => {
                    setHorarioAgendamento(e.target.value || '')
                    if (e.target.value) setInvalidHorarioAgendamento(false)
                  }}
                  invalid={invalidHorarioAgendamento}
                />
                {invalidHorarioAgendamento && (
                  <div className="text-danger small mt-1">
                    Selecione um horário válido (posterior ao atual)
                  </div>
                )}
              </Col>
            </Row>

            <div>
              <label className="form-label">Tipo de agendamento *</label>
              <CustomSelect
                placeholder="Selecione o tipo"
                options={optionsSelect.tiposAgendamento}
                accessorLabel="descricao"
                accessorValue="id"
                value={agendamento.tipoAgendamentoId}
                onChange={(value) => {
                  dispatch(
                    kanbanActions.setAgendamento({
                      ...agendamento,
                      tipoAgendamentoId: value || ''
                    })
                  )
                  if (value) setInvalidTipoAgendamento(false)
                }}
                invalid={invalidTipoAgendamento}
                isLoading={loadingSelect.tiposAgendamento}
              />
              {invalidTipoAgendamento && (
                <div className="text-danger small mt-1">
                  Selecione um tipo de agendamento
                </div>
              )}
            </div>

            <div>
              <label className="form-label">Observações</label>
              <InputCustom
                type="textarea"
                placeholder="Observações sobre o agendamento..."
                value={agendamento.observacao}
                onChange={(e) => {
                  dispatch(
                    kanbanActions.setAgendamento({
                      ...agendamento,
                      observacao: e.target.value || ''
                    })
                  )
                }}
              />
            </div>
          </div>
        </Section>
      </ModalContent>
    </SimpleModal>
  )
}

export default ModalAgendamento
